import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CriticitaSoglie, Environment, ModelNum } from '../../models/-index';
import { CrudGenericsService } from '../common/crud-generics';

@Injectable()
export class CriticitaSoglieService extends CrudGenericsService<CriticitaSoglie, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/CriticitaSoglie`);
    this.base = `${env.apiUrl}/api/CriticitaSoglie/`;
  }

  // ricalcola i fattori max
  GetMaxValueSoglia(): Observable<ModelNum> {
    const u = `${this.base}GetMaxValueSoglia`;
    return this.http.get<ModelNum>(u);
  }
  // conta
  SoglieCount(): Observable<ModelNum> {
    const u = `${this.base}SoglieCount`;
    return this.http.get<ModelNum>(u);
  }
}
